import React from "react";
import ParticlesBackground from "../components/Effects/ParticlesBackground";

const Comunity: React.FC = () => {
  return (
    <div>
      <ParticlesBackground />
      <h1>Comunidad</h1>
      <p>Página de comunidad en construcción...</p>
    </div>
  );
};

export default Comunity;
